export default "__VITE_ASSET__a6Z5lugs__"